import type { IHTTPRequestConfig } from '@cian/http-api';

export const ADDRESS_SUGGEST_URI: IHTTPRequestConfig['uri'] = {
  scheme: 'https',
  host: 'suggestions.dadata.ru',
  path: '/suggestions/api/4_1/rs/suggest/address',
};
